import {
  ElementRef,
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { FotoDialogComponent } from "app/shared/foto-dialog/foto-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { MedicoService } from "app/services/medico.service";
import { MercadopagoService } from "app/services/mercadopago.service";
import { GeneralService } from "app/services/general.service";
import { ConfirmDialogComponent } from "app/shared/confirm-dialog/confirm-dialog.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NotificationComponent } from "app/shared/notification/notification.component";
import {
  FormGroup,
  FormControl,
  Validators,
  FormArray,
  FormBuilder,
} from "@angular/forms";
import { TelefonoPais } from "app/models/telefonoPais.interface";
import { GlobalVariable } from "app/global/global";
import { TipoDocumento } from "app/models/tipoDocumento.interface";
import { SpinnerService } from "app/services/spinner.service";
import { CentroMedico } from "../../../models/centroMedico.interface";
import { Especialidad } from "../../../models/Especialidades.interface";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Router } from "@angular/router";
import {
  agendaOverlapValidator,
  passwordMatchValidator,
} from "./utils/validators";
import {
  buildAgendaFormGroup,
  patchAgendaFormGroup,
} from "../agenda-form/utils/agenda-form-builder";
import { ModalAdvertenciaAgendasComponent } from "../modal-advertencia-agendas/modal-advertencia-agendas.component";
import { Agenda } from "../../../models/agenda.interface";

@Component({
  selector: "app-crear-form-medico",
  templateUrl: "./crear-form-medico.component.html",
  styleUrls: ["./crear-form-medico.component.scss"],
})
export class CrearFormMedicoComponent implements OnInit {
  //
  funcionCorrecta: any;
  url: string = GlobalVariable.BASE_API_URL + "storage/images/medico/";
  editarValor: boolean;
  modoSplit: boolean = true;
  panelOpenState = false;
  @Input() set editar(value: boolean) {
    this.editarValor = value;
    this.panelOpenState = value ? true : false;
  }
  @Output() listar: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild("UploadFileInput") uploadFileInput: ElementRef;
  @ViewChild("divImagen") divImagen: ElementRef;
  telPais: FormControl = new FormControl();
  celPais: FormControl = new FormControl();
  imagen = "";
  nameImage: string = "";
  medico: any;
  file: File = null;
  myfilename = "Seleccionar archivo";
  telefonoPais: TelefonoPais[];
  filtroTelefonoPais: TelefonoPais[] = [];
  filtroCelularPais: TelefonoPais[] = [];
  tiposDocumentos: TipoDocumento[];
  provincias: any[] = [];
  checked = false;
  especialidades: Especialidad[] = [];
  sucursales: CentroMedico[] = [];
  errorDocumento: any;
  errorNumeroDocumento: any;
  errorTipoDocumento: any;
  errorMatricula: any;
  errorEmail: any;
  errorAgenda: any;
  errorDeclaracionJurada: any;
  selectedColor: string = "#c32af3";
  agenda: boolean;
  recetasDisponibles: number = 0;

  public telPaisBuscador: FormControl = new FormControl();
  public celPaisBuscador: FormControl = new FormControl();
  medicoForm = new FormGroup({
    id: new FormControl(""),
    title: new FormControl(""),
    name: new FormControl("", [
      Validators.required,
      Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/),
    ]),
    surname: new FormControl("", [
      Validators.required,
      Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/),
    ]),
    tipoDocumento: new FormControl(""),
    numeroDocumento: new FormControl(""),
    especialidad: new FormControl(""),
    matricula: new FormControl("", [
      Validators.required,
      Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/),
    ]),
    email: new FormControl("", Validators.email),
    telPais: new FormControl(""),
    telPaisBuscador: new FormControl(""),
    telCaract: new FormControl(""),
    telNumero: new FormControl(""),
    celPais: new FormControl(""),
    celPaisBuscador: new FormControl(""),
    celCaract: new FormControl(""),
    celNumero: new FormControl(""),
    agenda: new FormControl(false),
    codigoInterno: new FormControl(""),
    mpLinkPago: new FormControl(""),
    mpComisionPorcentaje: new FormControl(null),
    memberContactNo: new FormControl("Seleccionar archivo"),
    notificaciones: new FormControl(true),
    crearEstudiosMedicos: new FormControl(true),
    sucursalSeleccionada: new FormControl(""),
    sucursales: new FormArray([], agendaOverlapValidator()),
    color_agenda: new FormControl("#000ec4"),
    declaracion_jurada_aceptada: new FormControl(
      false,
      Validators.requiredTrue,
    ),
    licenseType: new FormControl(""),
    province: new FormControl(""),
    addressStreet: new FormControl(""),
    addressNumber: new FormControl(""),
    activo: new FormControl(true),
    habilitadoRecetas: new FormControl(false),
  });
  @Input() set response(value: any) {
    if (value) {
      this.formularioMedico(value);
      if (value.medico) {
        this.iniciarFormularioEditado(value);
      }
    }
  }
  public agendaFormGroup$: Observable<FormGroup>;
  private overlapError = 0;

  hidePassword = true;
  hideRepeatPassword = true;

  //
  constructor(
    public dialogs: MatDialog,
    private medicoService: MedicoService,
    private mercadopagoService: MercadopagoService,
    private generalService: GeneralService,
    private router: Router,
    private snackBar: MatSnackBar,
    private spinnerService: SpinnerService,
    private fb: FormBuilder,
  ) {}

  //
  ngOnInit(): void {
    this.overlapErrorHandler();
    this.initAgendaFormGroup();
    this.generalService.mostrar().subscribe({
      next: (data: any) => {
        const g = data?.general;
        const pagoActivo = g?.mp_pago_activo === undefined ? true : !!g.mp_pago_activo;
        this.modoSplit = pagoActivo && !!g?.mp_split_activo;
      },
    });
  }

  //
  clearNumeroDocumento() {
    this.errorNumeroDocumento = false;
    this.errorDocumento = false;
  }

  //
  clearTipoDocumento() {
    this.errorTipoDocumento = false;
    this.errorDocumento = false;
  }

  //
  clearMatricula = () => {
    this.errorMatricula = false;
  };

  //
  clearEmail = () => {
    this.errorEmail = false;
  };

  //
  clearDeclaracionJurada = () => {
    this.errorDeclaracionJurada = false;
  };

  //
  formularioMedico = (data: any) => {
    this.telefonoPais = data.listaTelefonoPais;
    this.filtroTelefonoPais = data.listaTelefonoPais;
    this.filtroCelularPais = data.listaTelefonoPais;
    this.tiposDocumentos = data.listatipoDocumento;
    this.especialidades = data.listaEspecialidad;
    this.sucursales = data.sucursales;
    this.recetasDisponibles = data.recetasDisponibles ?? 0;

    this.sucursales.forEach((s) => {
      this.agregarAgenda(s);
    });

    this.medicoService.getProvincias().subscribe({
      next: (data: any) => {
        this.provincias = data || [];
      },
      error: () => {
        this.provincias = [];
      },
    });
  };

  //
  iniciarFormularioEditado = (data: any) => {
    this.medico = data.medico;
    if (!this.imagen) {
      const imagen = this.medico.imagen || "ico_paciente.png";
      const esIcono = imagen.startsWith("ico_");
      this.imagen = esIcono ? `assets/img/${imagen}` : `${this.url}${imagen}`;
      this.divImagen.nativeElement.style.display = "block";
      this.nameImage = imagen;
    }

    this.agenda = this.medico.agenda;
    this.medicoForm.patchValue({
      id: this.medico.id,
      title: this.medico.title || "",
      name: this.medico.name || "",
      surname: this.medico.surname || "",
      tipoDocumento: this.medico.tipoDocumento
        ? parseInt(this.medico.tipoDocumento)
        : "",
      numeroDocumento: this.medico.numeroDocumento
        ? this.medico.numeroDocumento
        : "",
      especialidad: this.medico.especialidad ? this.medico.especialidad : "",
      matricula: this.medico.matricula ? this.medico.matricula : "",
      email: this.medico.email ? this.medico.email : "",
      telPais: this.medico.telPais ? this.medico.telPais : "",
      telPaisBuscador: "",
      telCaract: this.medico.telCaract ? this.medico.telCaract : "",
      telNumero: this.medico.telNumero ? this.medico.telNumero : "",
      celPais: this.medico.celPais ? this.medico.celPais : "",
      celPaisBuscador: "",
      celCaract: this.medico.celCaract ? this.medico.celCaract : "",
      celNumero: this.medico.celNumero ? this.medico.celNumero : "",
      agenda: this.medico.agenda.toString() == "0" ? false : true,
      codigoInterno: this.medico.codigoInterno ? this.medico.codigoInterno : "",
      memberContactNo: this.medico.imagen
        ? this.medico.imagen
        : "Seleccionar archivo",
      notificaciones:
        this.medico.notificaciones.toString() == "0" ? false : true,
      color_agenda: this.medico.color_agenda
        ? this.medico.color_agenda
        : "#000ec4",
      crearEstudiosMedicos: this.medico.crearEstudiosMedicos === 1,
      licenseType: this.medico.license_type || "",
      province: this.medico.province || "",
      addressStreet: this.medico.address_street || "",
      addressNumber: this.medico.address_number || "",
      activo:
        this.medico.cuenta_activada == 1 ||
        this.medico.cuenta_activada === true,
      habilitadoRecetas: this.medico.habilitado_recetas == 1,
      mpLinkPago: this.medico.mp_link_pago || "",
      mpComisionPorcentaje: this.medico.mp_comision_porcentaje || null,
      declaracion_jurada_aceptada: true,
    });

    if (data?.agendaMedico?.length > 0) {
      data.agendaMedico.forEach((agenda) => {
        const formGroup = this.obtenerFormGroupAgenda(agenda.id_sucursal);
        formGroup.patchValue({ id: agenda.id });
        patchAgendaFormGroup(formGroup, agenda);
      });
      setTimeout(() => {
        const centroMedicoPrincipal = this.sucursales.find(
          (s) => Number(s.sucursal) === 0,
        );

        this.medicoForm.patchValue({
          sucursalSeleccionada: centroMedicoPrincipal?.id,
        });
      });
    }
  };

  //
  filtrarTelPais = (event?: any) => {
    let textBuscador: string = this.telPaisBuscador.value;
    this.filtroTelefonoPais = this.telefonoPais.filter(function (element) {
      if (element.nombre.toUpperCase().includes(textBuscador.toUpperCase())) {
        return element;
      }
    });
  };

  //
  filtrarCelPais = (event?: any) => {
    let textBuscador: string = this.celPaisBuscador.value;
    this.filtroCelularPais = this.telefonoPais.filter(function (element) {
      if (element.nombre.toUpperCase().includes(textBuscador.toUpperCase())) {
        return element;
      }
    });
  };

  //
  fileChangeEvent = (event: any) => {
    var target = event.target || event.srcElement;
  };

  //
  cambiarAgenda = (event) => {
    this.agenda = event.checked;
    this.errorAgenda = false;
    setTimeout(() => {
      const centroMedicoPrincipal = this.sucursales.find(
        (s) => Number(s.sucursal) === 0,
      );

      this.medicoForm.patchValue({
        sucursalSeleccionada: centroMedicoPrincipal?.id,
      });
    });
  };

  //
  guardarMedico(form: any) {
    if (this.medicoForm.invalid) {
      this.medicoForm.markAllAsTouched();
      const faltantes = this.obtenerCamposObligatoriosFaltantes();
      this.openSnackBar(
        faltantes.length
          ? "Completá los campos obligatorios: " + faltantes.join(", ")
          : "Revisá los datos marcados en el formulario",
        "error",
      );
      return;
    }
    this.funcionCorrecta = this.editarValor
      ? this.editarMedico(form)
      : this.crearMedico(form);
  }

  private obtenerCamposObligatoriosFaltantes(): string[] {
    const obligatorios: { [control: string]: string } = {
      name: "Nombre",
      surname: "Apellido",
      matricula: "Matrícula",
      declaracion_jurada_aceptada: "Declaración jurada",
    };
    return Object.keys(obligatorios)
      .filter((control) => this.medicoForm.get(control)?.invalid)
      .map((control) => obligatorios[control]);
  }

  //
  crearMedico(form: any) {
    console.log("form => ", form);
    if (this.medicoForm.valid) {
      this.spinnerService.mostrarSpinner();
      this.medicoService.crear(this.nameImage, form, this.file).subscribe(
        (data) => {
          console.log("data", data);
          let response: any = data;
          if (response.statusError) {
            this.errorNumeroDocumento = response.errorNumeroDocumento;
            this.errorTipoDocumento = response.errorTipoDocumento;
            this.errorDocumento = response.errorDocumento;
            this.errorMatricula = response.errorMatricula;
            this.errorEmail = response.errorEmail;
            this.errorAgenda = response.errorAgenda;
            this.errorDeclaracionJurada = response.errorDeclaracionJurada;
            this.spinnerService.ocultarSpinner();
            this.openSnackBar(response.mensaje || "Guardado fallido", "error");
          } else {
            this.openSnackBar(
              "Médico creado correctamente. Se ha enviado un email de activación.",
              "exito",
            );
            this.listar.emit();
            this.resetearFormulario();
          }
        },
        (error) => {
          console.log("error", error);
          this.spinnerService.ocultarSpinner();
          this.openSnackBar("Guardado fallido", "error");
        },
      );
    } else {
      this.openSnackBar("Guardado fallido", "error");
    }
  }

  //
  editarMedico(form: any) {
    if (this.medicoForm.valid) {
      this.spinnerService.mostrarSpinner();
      this.medicoService.editar(this.nameImage, form, this.file).subscribe(
        (data) => {
          let response: any = data;
          if (response.statusError) {
            this.errorNumeroDocumento = response.errorNumeroDocumento;
            this.errorTipoDocumento = response.errorTipoDocumento;
            this.errorDocumento = response.errorDocumento;
            this.errorMatricula = response.errorMatricula;
            this.errorEmail = response.errorEmail;
            this.errorAgenda = response.errorAgenda;
            this.spinnerService.ocultarSpinner();
            this.openSnackBar("Editado fallido", "error");
          } else {
            this.spinnerService.ocultarSpinner();
            this.openSnackBar("Editado exitoso", "exito");
            this.router.navigate(["/seccion-panel/medico/"]);
          }
        },
        (error) => {
          console.log(error);
          this.spinnerService.ocultarSpinner();
          this.openSnackBar("Editado fallido", "error");
        },
      );
    }
  }

  //
  ocultarMostrar = () => {
    this.panelOpenState = this.panelOpenState == true ? false : true;
  };

  //
  resetearFormulario = () => {
    this.file = null;
    this.medicoForm.reset();
    this.imagen = "";
    this.myfilename = "Seleccionar archivo";
    this.medicoForm.patchValue({
      title: "",
      name: "",
      surname: "",
      tipoDocumento: "",
      numeroDocumento: "",
      especialidad: "",
      matricula: "",
      email: "",
      telPais: "",
      telPaisBuscador: "",
      telCaract: "",
      telNumero: "",
      celPais: "",
      celPaisBuscador: "",
      celCaract: "",
      celNumero: "",
      agenda: false,
      codigoInterno: "",
      memberContactNo: "Seleccionar archivo",
      notificaciones: true,
      crearEstudiosMedicos: true,
      sucursalSeleccionada: "",
      sucursales: [],
      color_agenda: "#000ec4",
      declaracion_jurada_aceptada: false,
      licenseType: "",
      province: "",
      addressStreet: "",
      addressNumber: "",
      activo: true,
      habilitadoRecetas: false,
    });
    this.agenda = false;
    this.errorAgenda = false;
    this.errorDeclaracionJurada = false;
    this.divImagen.nativeElement.style.display = "none";
    this.panelOpenState = false;
    this.sucursales.forEach((s) => {
      this.agregarAgenda(s);
    });
  };

  //
  openDialogFoto = () => {
    const dialogRef = this.dialogs.open(FotoDialogComponent, {
      width: "50%",
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res.data == "" && res.img == "") {
      } else {
        if (
          res.data.id == "ico_paciente.png" ||
          res.data.id == "ico_pacienteM.png"
        ) {
          this.myfilename = res.data.id;
          this.imagen = "assets/img/" + res.data.id + "";
          this.nameImage = res.data.id;
          this.divImagen.nativeElement.style.display = "block";
        } else {
          this.myfilename = res.data.name;

          this.imagen = res.img;
          this.divImagen.nativeElement.style.display = "block";
          this.file = res.data;
          this.nameImage = "";
        }
      }
    });
  };

  //
  openSnackBar = (message: string, action: string) => {
    this.snackBar.openFromComponent(NotificationComponent, {
      data: {
        message: message,
        action: action,
      },
      duration: 2500,
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: [action],
    });
  };

  agregarAgenda(sucursal: CentroMedico) {
    const agendaForm = buildAgendaFormGroup(this.fb);
    agendaForm.addControl("id", this.fb.control(""));
    agendaForm.addControl("id_sucursal", this.fb.control(sucursal.id));
    agendaForm.addControl("esSucursal", this.fb.control(Number(sucursal.sucursal) !== 0));
    (this.medicoForm.get("sucursales") as FormArray).push(agendaForm);
  }
  private initAgendaFormGroup() {
    this.agendaFormGroup$ =
      this.medicoForm.controls.sucursalSeleccionada.valueChanges.pipe(
        map((sucursalId: number) => {
          return this.obtenerFormGroupAgenda(sucursalId);
        }),
      );
  }

  private obtenerFormGroupAgenda(sucursalId?: number): FormGroup {
    const agendaIndex = this.medicoForm.value.sucursales.findIndex(
      (s) => s.id_sucursal === sucursalId,
    );

    const sucursales = this.medicoForm.get("sucursales") as FormArray;
    return sucursales.at(agendaIndex) as FormGroup;
  }

  private abrirModalAdvertenciaAgendas(
    errorData: {
      overlappingDays: string[];
      agenda1: Agenda;
      agenda2: Agenda;
    }[],
  ) {
    errorData.forEach((element) => {
      element.agenda1 = {
        ...element.agenda1,
        nombre_sucursal: this.sucursales.find(
          (s) => s.id === element.agenda1.id_sucursal,
        ).nombre,
      };

      element.agenda2 = {
        ...element.agenda2,
        nombre_sucursal: this.sucursales.find(
          (s) => s.id === element.agenda2.id_sucursal,
        ).nombre,
      };
    });
    const dialogRef = this.dialogs.open(ModalAdvertenciaAgendasComponent, {
      height: "fit-content",
      data: { errorData },
    });
  }

  private overlapErrorHandler() {
    this.medicoForm.get("sucursales").statusChanges.subscribe((status) => {
      if (
        status == "INVALID" &&
        this.medicoForm.get("sucursales")?.errors?.agendaOverlap.length > 0 &&
        this.medicoForm.get("sucursales")?.errors?.agendaOverlap.length >
          this.overlapError
      ) {
        this.abrirModalAdvertenciaAgendas(
          this.medicoForm.get("sucursales")?.errors?.agendaOverlap,
        );
        this.overlapError += 1;
      }

      if (
        status === "VALID" ||
        this.medicoForm.get("sucursales")?.errors?.agendaOverlap.length === 0
      ) {
        this.overlapError = 0;
      }
    });
  }

  public overlapErrorDays(idSucursal: number): string[] {
    const agendaOverlap =
      this.medicoForm.get("sucursales")?.errors?.agendaOverlap;

    if (!agendaOverlap || !Array.isArray(agendaOverlap)) {
      return [];
    }

    for (const overlap of agendaOverlap) {
      if (
        overlap.agenda1?.id_sucursal === idSucursal ||
        overlap.agenda2?.id_sucursal === idSucursal
      ) {
        return overlap.overlappingDays || [];
      }
    }

    return [];
  }

  //
  enviarLinkMp() {
    if (!this.medico?.id) return;
    const yaEnviado = !!this.medico.mp_last_link_sent_at;
    this.spinnerService.mostrarSpinner();

    this.mercadopagoService.enviarLink(this.medico.id).subscribe(
      (res) => {
        this.spinnerService.ocultarSpinner();
        this.medico.mp_last_link_sent_at = res?.sent_at || new Date().toISOString();
        this.snackBar.open(
          yaEnviado
            ? "Link de MercadoPago reenviado. El anterior quedó inválido."
            : "Link de MercadoPago enviado al médico.",
          "X",
          { duration: 5000, panelClass: ["snackbar"] },
        );
      },
      (error) => {
        this.spinnerService.ocultarSpinner();
        this.snackBar.open(
          error.error?.error || "Error al enviar el link de MercadoPago",
          "X",
          { duration: 5000, panelClass: ["snackbar", "error"] },
        );
      },
    );
  }

  //
  desvincularMp() {
    if (!this.medico?.id) return;

    const dialogRef = this.dialogs.open(ConfirmDialogComponent, {
      width: "50%",
      data: "vínculo con MercadoPago",
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;

      this.spinnerService.mostrarSpinner();
      this.mercadopagoService.desvincular(this.medico.id).subscribe(
        () => {
          this.spinnerService.ocultarSpinner();
          this.medico.mp_active = false;
          this.medico.mp_linked_at = null;
          this.medico.mp_last_link_sent_at = null;
          this.snackBar.open("Médico desvinculado de MercadoPago.", "X", {
            duration: 5000,
            panelClass: ["snackbar"],
          });
        },
        () => {
          this.spinnerService.ocultarSpinner();
          this.snackBar.open("Error al desvincular MercadoPago", "X", {
            duration: 5000,
            panelClass: ["snackbar", "error"],
          });
        },
      );
    });
  }
}
